import type { ReduxState } from "model/state"

export function selectIsDashboardStoreLoaded(state: ReduxState, dashboardId: string): boolean {
  const { core, model, trade, optimization, panels } = state.dashboard
  return Boolean(
    core[dashboardId]?.isPreferencesLoaded
    && model[dashboardId]?.isPreferencesLoaded
    && trade[dashboardId]?.isPreferencesLoaded
    && optimization[dashboardId]?.isPreferencesLoaded
    && panels[dashboardId]?.isPreferencesLoaded,
  )
}
